export const openBlob = (blob: Blob) => {
  const url = window.URL.createObjectURL(blob)
  window.open(url, '_blank')
}

export const downloadBlob = (blob: Blob, filename: string) => {
  const url = window.URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  a.style.display = 'none'
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  window.URL.revokeObjectURL(url)
}

export const downloadFileFromUrl = (url: string, filename: string) => {
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  a.style.display = 'none'
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
}

// Neither navigating to the asset URL nor fetching it works; see the proxy
// route for why.
export const openFileFromUrl = (url: string) => {
  const viewerUrl = `/api/asset/?url=${encodeURIComponent(url)}`
  window.open(viewerUrl, '_blank', 'noopener,noreferrer')
}
